import React from 'react';
import { NavLink , useHistory} from 'react-router-dom';

const CardSevice = (props) => {
  const { data } = props;
  const history = useHistory(); // useHistory hook'unu burada kullanın

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  }
  return (
    <NavLink to={`/servislerimiz/detay/${data.url}`} className="wrapper__card-service color__black d-inline-block w-100" onClick={handleLinkClick}>
      <img src={data.img} className='img' alt="" />
      <div className="desc">
        <div className="h5 medium font__size--20 text__20-1024 text-uppercase">{data.title}</div>
        <p className="normal font__size--16 text__16-1024 roboto color__gray-2">
          {data.desc}
        </p>
      </div>
    </NavLink>
  );
}

export default CardSevice;
